import React, { useState } from "react"
import {
  nePasManquerContainer,
  nePasManquerTitle,
  nePasManquerHeader,
  nePasManquerDescription,
  listPageFilters,
  listPageFiltersTaxo,
} from "./ne-pas-manquer.module.scss"
import {
  ListNePasManquerHeader,
  ListPageFiltersTaxo,
} from "./ne-pas-manquer-styled"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import RenderNePasManquer from "./RenderNePasManquer/render-ne-pas-manquer"
import { useNePasManquer } from "gatsby-theme-blank/src/components/Home/NePasManquer/ne-pas-manquer-query"
import { getPublishedData } from "gatsby-theme-blank/src/components/get-published-data"

//-----------------------Parent component---------------------------//

const ListNePasManquer = () => {
  const data = useNePasManquer()
  const finalData = getPublishedData(data.allNodePage.edges)
  const [choosenTag, setChoosenTag] = useState("Tous")
  let allTaxos = finalData
    .map(({ node }) => {
      return node.relationships.field_taxonomie_thematique[0]?.name
    })
    .filter((element) => element)
  allTaxos = [...new Set(allTaxos)]
  allTaxos.unshift("Tous")
  if (finalData.length === 0) {
    return null
  }
  let finalFilteredData = finalData
  if (choosenTag !== "Tous") {
    finalFilteredData = finalData.filter(
      ({ node }) =>
        node.relationships?.field_taxonomie_thematique[0]?.name === choosenTag
    )
  }
  return (
    <>
      <ListNePasManquerHeader className={nePasManquerHeader}>
        <h2 className={nePasManquerTitle}>
          {data.taxonomyTermZoneDefinie?.field_label || "À ne pas manquer"}
        </h2>
        <div className={listPageFilters}>
          {allTaxos.map((taxo) => {
            let activeBool = false
            if (choosenTag === taxo) {
              activeBool = true
            }
            return (
              <ListPageFiltersTaxo
                activeBool={activeBool}
                key={taxo}
                onClick={() => {
                  setChoosenTag(taxo)
                }}
                className={listPageFiltersTaxo}
              >
                {taxo}
              </ListPageFiltersTaxo>
            )
          })}
        </div>
      </ListNePasManquerHeader>
      {data.taxonomyTermZoneDefinie.description && (
        <div className={nePasManquerDescription}>
          <ContentTransformer
            content={data.taxonomyTermZoneDefinie.description.processed}
          ></ContentTransformer>
        </div>
      )}
      <div className={nePasManquerContainer}>
        <RenderNePasManquer nePasManquerData={finalFilteredData} />
      </div>
    </>
  )
}
//-----------------------Parent component---------------------------//

export default ListNePasManquer
